import { useStyletron } from '@thanx/uikit/theme'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'
import { Link } from 'react-router-dom'

const t = buildTranslate('pos_configurations.provider_tabs')

// Tab body for the OLO tab on a multi-provider POS Configurations
// page. Olo menus aren\'t shared across locations (Decision 1,
// 2026-05-15), so the menu-grouped surface has nothing to show; the
// operator gets routed to /locations where Olo errors live per-row.
//
// STUB: this is intentionally empty-state copy as a placeholder for a
// future upgrade. Once Olo exposes a per-location error feed we can
// render the actual error surface here instead of routing away.
const OloTabContent = () => {
  const [css] = useStyletron()
  return (
    <div
      className={`d-flex flex-column align-items-center text-center p-xl ${css({
        backgroundColor: palette.white,
        border: `1px solid ${palette.grey20}`,
        borderRadius: '4px',
      })}`}
    >
      <i
        className={`fa fa-info-circle mb-m ${css({
          color: palette.grey50,
          fontSize: '48px',
        })}`}
        aria-hidden="true"
      />
      <h3
        className={`bold mb-xs ${css({
          color: palette.grey90,
          fontSize: '20px',
          lineHeight: '28px',
        })}`}
      >
        {t('olo_tab_title') as string}
      </h3>
      <p
        className={`body-text-3 mb-m ${css({
          color: palette.grey70,
          maxWidth: '560px',
        })}`}
      >
        {t('olo_tab_description') as string}
      </p>
      <Link className="btn btn-primary" to="/locations">
        {t('olo_tab_cta') as string}
      </Link>
    </div>
  )
}

export default OloTabContent
